import React, { Component } from 'react'
import { YearContainer } from '../../Commons/Year'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import {
    sanitizeMilitaryId,
    translateFormFieldLabel,
    translateFormFieldValue,
} from '../../../../../../../helpers/collaborativeIndexations'
import Select from '../../../../Forms/Commons/Select'
import classNames from "classnames";

class MilitaryRecord extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        militaryRecordRegistries: PropTypes.array.isRequired,
        isInvalidField: PropTypes.func.isRequired,
    }

    constructor()
    {
        super()

        this.updateMilitaryId = this.updateMilitaryId.bind(this)
        this.updateMilitaryRecordRegistry = this.updateMilitaryRecordRegistry.bind(this)
        this.militaryRecordRegistries = this.militaryRecordRegistries.bind(this)

        this.mainField = React.createRef()
    }

    updateMilitaryId(event)
    {
        this.props.updateFieldValue('militaryId', sanitizeMilitaryId(event.target.value))
    }

    updateMilitaryRecordRegistry(option)
    {
        this.props.updateFieldValue('militaryRecordRegistry', option.value)
    }

    militaryRecordRegistries()
    {
        return this.props.militaryRecordRegistries.map((militaryRecordRegistry) => (
            { value: militaryRecordRegistry, label: militaryRecordRegistry }
        ))
    }

    componentDidMount()
    {
        this.mainField.current.focus()
    }

    render()
    {
        const { t, fields, militaryRecordRegistries, isInvalidField } = this.props

        return (
            <div>
                <div>
                    { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.militaryRecord.title') }
                </div>
                <div className={'form-group'}>
                    <label>{t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.militaryRecord.documentType') }</label>
                    <span className={'readonly-field'}>{translateFormFieldValue(t, 'documentType', 'militaryRecord')}</span>
                </div>
                <div className={'form-group'}>
                    <label>{t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.militaryRecord.militaryId') }</label>
                    <input
                        ref={this.mainField}
                        className={'military-id'}
                        type={'number'}
                        value={fields.militaryId !== null ? fields.militaryId : ''}
                        onChange={this.updateMilitaryId}
                    />
                </div>
                <YearContainer fieldName={'conscriptionYear'} label={translateFormFieldLabel(t, 'conscriptionYear')}/>
                <div className={'form-group'}>
                    <label>{t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.militaryRecord.militaryRecordRegistry')}</label>
                    <Select
                        options={[
                            { value: '', label: t('visualizer:toolbar.left.collaborativeIndexationCreation.fields.values.militaryRecordRegistry.default') },
                            ...this.militaryRecordRegistries()
                        ]}
                        value={fields.militaryRecordRegistry === null ? '' : fields.militaryRecordRegistry}
                        onChange={this.updateMilitaryRecordRegistry}
                        isDisabled={militaryRecordRegistries.length === 1}
                        className={classNames({"error": isInvalidField('militaryRecordRegistry')})}
                        isSearchable={true}
                    />
                </div>
            </div>
        )
    }
}

export default withTranslation()(MilitaryRecord)
